// extracted by mini-css-extract-plugin
export default {"sidebar-outer":"sidebar_sidebar-outer__cO4Zl","sidebar-inner":"sidebar_sidebar-inner__sh3Sa","nav":"sidebar_nav__oCcXd","divider":"sidebar_divider__IxXsL"};